import {
  oldToNewBrowsePathsMap,
  superBrowseToBrowseMap,
  TMOBILE_PLACEHOLDER_URLS,
} from '../../constants/Urls';

import { getNotFoundPath } from './shared';

export function isNewBrowseCategoryPath(pathname) {
  return /^\/browse\/music\/genres\/[\w]+$/.test(pathname);
}

export function isNewBrowseActivitiesPath(pathname) {
  return /^\/browse\/music\/activities\/[\w]+$/.test(pathname);
}

export function isNewBrowseDecadesPath(pathname) {
  return /^\/browse\/music\/decades\/[\w]+$/.test(pathname);
}

export function isNewBrowsePodcastsPath(pathname) {
  return /^\/browse\/podcasts\/[\w]+$/.test(pathname);
}

export function getBrowsePath() {
  return '/browse';
}

export function isBrowsePath(path) {
  const browse = getBrowsePath();
  return path === browse || (path && path.indexOf(browse + '/') === 0);
}

export function getBrowseGenreCategoryPath(categoryName) {
  return `/music/${categoryName}`;
}

export function getNewBrowseDecadesPath() {
  return '/browse/music/decades';
}

export function mapOldBrowseToNewBrowse(pathname) {
  if (pathname in oldToNewBrowsePathsMap) {
    return oldToNewBrowsePathsMap[pathname];
  }

  return getNotFoundPath();
}

export function mapSuperBrowseToBrowse(pathname) {
  if (pathname in superBrowseToBrowseMap) {
    return superBrowseToBrowseMap[pathname];
  }

  return getNotFoundPath();
}

export function isOldBrowseCategoryPath(pathname) {
  return /^\/music\/genres\/.+$/.test(pathname);
}

export function isOldBrowseDecadesPath(pathname) {
  return /^\/music\/decades\/.+$/.test(pathname);
}

export function isOldBrowsePath(pathname) {
  return /^\/music\/.+$/.test(pathname);
}

export function isSuperBrowsePath(pathname) {
  return pathname.startsWith('/browse/content');
}

export function getBrowsePodcastsPath() {
  return '/browse/podcasts';
}

export function isPodcastPath(pathname) {
  return pathname.startsWith('/podcast');
}

export function getBrowseEpisodesPath() {
  return '/browse/podcasts/episodes';
}

export function isTmobileBrowsePath(pathname) {
  return TMOBILE_PLACEHOLDER_URLS[pathname] === true;
}
